var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.report,"items-per-page":50,"sort-by":"name","sort-desc":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }